import {Button} from '@/components/button';
import {DataTable} from '@/components/table/datatable';
import {Tag} from '@/components/tag';
import {idrFormatter} from '@/lib/utils/currency';
import {ArrowUpIcon, ArrowUpTrayIcon, CreditCardIcon, EyeIcon} from '@heroicons/react/24/solid';
import {ColumnDef} from '@tanstack/react-table';
import {CogIcon, UsersIcon} from "@heroicons/react/24/outline";
import {useEffect, useState} from "react";
import {OtsSetupModal} from "@/routes/org/event/slug/ots/payments/_modals/setup";
import {OtsPayModal} from "@/routes/org/event/slug/ots/payments/_modals/pay";
import {ThemeColor} from "@/lib/utils";
import moment from "moment";
import {useLocation, useParams} from "react-router-dom";
import {AppDispatch} from "@/root/store";
import {useDispatch, useSelector} from "react-redux";
import {GetOtsTransactionsByEvent} from "@/services/ots";
import {OtsUploadModal} from "@/routes/org/event/slug/ots/payments/_modals/upload";

interface Transaction {
    id: string;
    reference: string;
    booking_reference: string;
    name: string;
    date: string;
    ticket: string;
    booking_type: string;
    quantity: number;
    event: string;
    subtotal: number;
    status: {
        label: string,
        color: ThemeColor
    };
}

const columns: ColumnDef<Transaction>[] = [
    {
        header: 'Kode Booking',
        accessorKey: 'booking_reference',
    },
    {
        header: 'Nama',
        accessorKey: 'name',
    },
    {
        header: 'Tanggal',
        cell: ({row}) => {
            const transactionDate = row.original.date;
            return moment(transactionDate).format('LL');
        },
    },
    {
        header: 'Event - Tiket',
        cell: ({row}) => {
            return (
                <>
                    {row.original.event} -{' '}
                    <span className='text-info'>{row.original.ticket}</span>{' '}
                    <span className='text-neutral-70'>{`(x${row.original.quantity})`}</span>
                </>
            );
        },
    },
    {
        header: 'Tipe Pembelian',
        accessorKey: 'booking_type',
    },
    {
        accessorKey: 'nominal',
        header: 'Nominal',
        cell: ({row}) => {
            const nominal = row.original.subtotal;
            return (
                <span className='text-danger'>{idrFormatter.format(nominal)}</span>
            );
        },
    },
    {
        accessorKey: 'status',
        header: 'Status',
        cell: ({row}) => {
            const status = row.original.status;
            return <Tag color={status.color}>{status.label}</Tag>;
        },
    },
    {
        header: 'Aksi',
        cell: ({row}) => {
            return (
                <div className={'flex gap-2'}>
                    <Button element={'link'} to={'/transaction/' + row.original.reference} variant='neutral'
                            size='sm' leftIcon={<EyeIcon/>}>
                        Detail
                    </Button>
                </div>
            );
        },
    },
];

export function OrgOtsSystem() {
    const [setupModal, setSetupModal] = useState(false)
    const [payModal, setPayModal] = useState(false)
    const [uploadModal, setUploadModal] = useState(false)
    const location = useLocation();
    const {slug} = useParams();
    const dispatch: AppDispatch = useDispatch();

    const {transactions, paginator} = useSelector((state: any) => state.ots);

    const queryParams = new URLSearchParams(location.search);
    const searchQuery: string = queryParams.get('search') ?? '';

    useEffect(() => {
        dispatch(GetOtsTransactionsByEvent(slug, searchQuery))
    }, [slug, searchQuery])

    return (
        <>
            <OtsSetupModal setupModal={setupModal} setSetupModal={() => {
                setSetupModal(false)
            }}/>

            <OtsPayModal payModal={payModal} setPayModal={() => {
                setPayModal(false)
            }}/>

            <OtsUploadModal uploadModal={uploadModal} setUploadModal={() => {
                setUploadModal(false)
            }}/>

            <DataTable ctaButton={
                <div className={'flex gap-2'}>
                    <Button variant='primary'
                            onClick={() => setUploadModal(true)}
                            leftIcon={<ArrowUpTrayIcon/>} />
                    <Button variant='primary'
                            onClick={() => setPayModal(true)}
                            leftIcon={<UsersIcon/>}>
                        Tambah pembeli
                    </Button>
                    {/*<Button onClick={() => setSetupModal(true)} variant='neutral' leftIcon={<CogIcon />} />*/}
                </div>
            } name='Penjualan On The Spot' columns={columns} data={transactions} total={paginator.to}
                       currentTotal={paginator.total} currentPage={paginator.current_page} pages={paginator.last_page}/>
        </>
    );
}
